import { Autocomplete, TextField } from '@mui/material';
import { PERMISSIONS } from '@vy/types';
import React from 'react';
import { renderWithPermissions } from '../../../../../../../../services/render-with-permissions';
import type { RoleLabelValuePair } from '../members-table-types/role-label-value-pair';

type RoleDropdownProps = {
  options: RoleLabelValuePair[];
  defaultRole: RoleLabelValuePair;
  onChange(selectedRole: RoleLabelValuePair): void;
};

export const RoleDropdown: React.FC<RoleDropdownProps> = ({ defaultRole, onChange, options }) => (
  <>
    {renderWithPermissions([PERMISSIONS.USER_UPDATE], (hasPermission) => (
      <Autocomplete
        autoComplete
        fullWidth
        disableClearable
        disabled={!hasPermission}
        options={options}
        value={defaultRole}
        isOptionEqualToValue={(option, value) => option.role === value.role}
        onChange={(_event, selectedRoleValuePair) => onChange(selectedRoleValuePair)}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => <TextField {...params} />}
        sx={{
          '& .MuiAutocomplete-inputRoot': {
            backgroundColor: 'transparent',
          },
        }}
      />
    ))}
  </>
);
